module.exports = __webpack_public_path__ + "img/teacher_10.80e15a45.png";